import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'
import detail from '../views/detail/index.vue'
import Magazine from '../views/magazine/index.vue'
import MagazineViewer from '../views/magazine/MagazineViewer.vue'
import AboutUs from '../views/pages/AboutUs.vue'
import AdService from '../views/pages/AdService.vue'
import Copyright from '../views/pages/Copyright.vue'
import ContactUs from '../views/pages/ContactUs.vue'
import ForgetPassword from '../views/pages/ForgetPassword.vue'
import UserAgreement from '../views/pages/UserAgreement.vue'
import PrivacyTerms from '../views/pages/PrivacyTerms.vue'
import Login from '../views/pages/Login.vue'
import LoginPage from '../views/login/index.vue'
import Register from '../views/pages/Register.vue'
import ResetPassword from '../views/pages/ResetPassword.vue'
import RegisterSuccess from '../views/pages/RegisterSuccess.vue'
import UserCenter from '../views/pages/UserCenter.vue'
import CompanyCenter from '../views/pages/CompanyCenter.vue'
import NewsSearch from '../views/pages/NewsSearch.vue'
import Personal from '../views/my/index.vue'
import NotFound from '../views/pages/NotFound.vue'
import ComingSoon from '../views/pages/ComingSoon.vue'
import ChannelOne from '../views/channel/ChannelOne.vue'
import ChannelTwo from '../views/channel/ChannelTwo.vue'
import ChannelThree from '../views/channel/ChannelThree.vue'
import ChannelFour from '../views/channel/ChannelFour.vue'
import SpecialPage from '../views/special/index.vue'
import SiteNavigation from '../views/pages/SiteNavigation.vue'
import BrandResult from '../views/special/BrandResult.vue'
import BrandIndex from '../views/special/BrandIndex.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/detail',
    name: 'detail',
    component: detail
  },
  {
    path: '/zp/a/:id?',
    name: 'article-detail',
    component: detail
  },
  {
    path: '/magazine',
    name: 'magazine',
    component: Magazine
  },
  {
    path: '/magazine/viewer',
    name: 'magazine-viewer',
    component: MagazineViewer
  },
  {
    path: '/search',
    name: 'news-search',
    component: NewsSearch
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: AboutUs
  },
  {
    path: '/ad-service',
    name: 'ad-service',
    component: AdService
  },
  {
    path: '/copyright',
    name: 'copyright',
    component: Copyright
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: ContactUs
  },
  {
    path: '/user-agreement',
    name: 'user-agreement',
    component: UserAgreement
  },
  {
    path: '/privacy-terms',
    name: 'privacy-terms',
    component: PrivacyTerms
  },
  {
    path: '/old-login',
    name: 'old-login',
    component: Login
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: ForgetPassword
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword
  },
  {
    path: '/register-success',
    name: 'register-success',
    component: RegisterSuccess
  },
  {
    path: '/user-center',
    name: 'user-center',
    component: UserCenter
  },
  {
    path: '/my',
    name: 'my',
    component: Personal
  },
  {
    path: '/company-center',
    name: 'company-center',
    component: CompanyCenter
  },
  {
    path: '/channel/one',
    name: 'channel-one',
    component: ChannelOne
  },
  {
    path: '/channel/two',
    name: 'channel-two',
    component: ChannelTwo
  },
  {
    path: '/channel/three',
    name: 'channel-three',
    component: ChannelThree
  },
  {
    path: '/channel/four',
    name: 'channel-four',
    component: ChannelFour
  },
  {
    path: '/special/page',
    name: 'special-page',
    component: SpecialPage
  },
  {
    path: '/site-navigation',
    name: 'site-navigation',
    component: SiteNavigation
  },
  {
    path: '/coming-soon',
    name: 'coming-soon',
    component: ComingSoon
  },
  {
    path: '/brand-index',
    name: 'brand-index',
    component: BrandIndex
  },
  {
    path: '/brand-result',
    name: 'brand-result',
    component: BrandResult
  },
  {
    path: '*',
    name: 'not-found',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 判断是否为手机端访问
const isMobile = () => {
  const ua = navigator.userAgent
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  return mobileRegex.test(ua)
}

// 获取移动端域名
const getMobileUrl = () => {
  return process.env.VUE_APP_MOBILE_URL || 'https://mobile.cbrand.com.cn'
}

// 路由解析 - 添加 .html 后缀（针对文章详情页）
router.beforeResolve((to, from, next) => {
  // 只处理文章详情页面
  if (to.name === 'article-detail' && to.params.id) {
    const newsCode = to.params.id
    
    // 如果当前路径不包含.html 且 params.id 也不包含.html，则自动重定向
    if (!newsCode.endsWith('.html')) {
      const newPath = `/zp/a/${newsCode}.html`
      console.log('[Router] Redirecting to HTML suffix:', from.path, '->', newPath)
      // 保留原有的查询参数
      return next({ path: newPath, query: from.query, replace: true })
    }
  }
  
  next()
})

// 路由守卫 - 移动端拦截
router.beforeEach((to, from, next) => {
  // 如果不是手机端访问，直接放行
  if (!isMobile()) {
    next()
    return
  }

  // 定义需要跳转的移动端路径规则
  const mobileUrl = getMobileUrl()
  
  // 首页跳转
  if (to.path === '/') {
    window.location.href = `${mobileUrl}/`
    return 'abort'
  }

  // 文章详情页面：/zp/a/:id(包括 .html 后缀) -> https://mobile.cbrand.com.cn/detail?newsCode=文章编号
  if (to.name === 'article-detail' && to.params.id) {
    // 移除可能的.html 后缀
    const newsCode = to.params.id.replace(/\.html$/, '')
    window.location.href = `${mobileUrl}/detail?newsCode=${newsCode}`
    return 'abort'
  }

  // 文章详情页面：/detail?newsCode=文章编号（如果需要）
  if (to.path === '/detail' && to.query.newsCode) {
    window.location.href = `${mobileUrl}/detail?newsCode=${to.query.newsCode}`
    return 'abort'
  }

  // 活动页面：/special/page?specialCode=活动编号 -> https://mobile.cbrand.com.cn/special?specialCode=活动编号
  if (to.name === 'special-page' && to.query.specialCode) {
    window.location.href = `${mobileUrl}/special?specialCode=${to.query.specialCode}`
    return 'abort'
  }

  // 频道页面统一跳转
  // /channel/one?categoryId=频道 ID -> https://mobile.cbrand.com.cn/channel/index?categoryId=频道 ID
  if (to.path.startsWith('/channel/') && to.query.categoryId) {
    window.location.href = `${mobileUrl}/channel/index?categoryId=${to.query.categoryId}`
    return 'abort'
  }

  // 登录页面：/login -> https://mobile.cbrand.com.cn/login
  if (to.path === '/login') {
    window.location.href = `${mobileUrl}/login`
    return 'abort'
  }

  // 个人中心：/my -> https://mobile.cbrand.com.cn/my
  if (to.path === '/my') {
    window.location.href = `${mobileUrl}/my`
    return 'abort'
  }

  // 其他页面正常访问
  next()
})

export default router
